import { render, staticRenderFns } from "./ZoneEditor.vue?vue&type=template&id=2af45b73&scoped=true"
import script from "./ZoneEditor.vue?vue&type=script&lang=ts"
export * from "./ZoneEditor.vue?vue&type=script&lang=ts"
import style0 from "./ZoneEditor.vue?vue&type=style&index=0&id=2af45b73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af45b73",
  null
  
)

export default component.exports